'use client'

import Badge from '@dd3tech/wiggui/Badge'
import Button from '@dd3tech/wiggui/Button'
import CopyToClipboard from '@dd3tech/wiggui/CopyToClipboard'
import Flex from '@dd3tech/wiggui/Flex'
import GoogleIcon from '@dd3tech/wiggui/GoogleIcon'
import Input from '@dd3tech/wiggui/Input'
import Modal from '@dd3tech/wiggui/Modal'
import OptionButton from '@dd3tech/wiggui/OptionButton'
import Text from '@dd3tech/wiggui/Text'
import { useShareFileProperty } from './hooks/useShareFileProperty'
import { DropdownContact } from './components/DropdownContact'
import { ROUTES } from '../../constants/routes'

export const ModalShareFile = () => {
  const {
    dataCustomer,
    handleOnChange,
    modalShareFile,
    onClose,
    handleOnClick,
    isLoading,
    handleOnChangePhoneCode,
    isLoadingSearch,
    resultSearchCustomer,
    searchValueCustomer,
    handleSelectContact,
    setSearchValueCustomer,
    isNewCustomer,
    selectedCustomer,
    handleNewCustomer,
    handleResetContact,
    debounceSearchValueCustomer,
    formIsDisabled,
    validateEmail,
    emailIsInvalid
  } = useShareFileProperty()

  const allInputsIsFilled =
    ((dataCustomer?.email?.length > 0 && !emailIsInvalid) ||
      (dataCustomer?.phone && dataCustomer?.phoneCode)) &&
    dataCustomer?.name

  if (!modalShareFile?.isOpen) {
    return null
  }

  return (
    <Modal
      className="w-full max-w-lg"
      enableBgBlur
      onClose={onClose}
      isOpen={modalShareFile?.isOpen}
    >
      <Modal.Header title="Compartir ficha" isShowCloseButton isShowDivider />
      <Modal.Body className="p-6 w-full flex gap-6 flex-col items-center justify-center">
        <Flex dir="row" items="center" justify="start" wFull gap="gap-2.5">
          <CopyToClipboard
            textToCopy={modalShareFile?.linksToShare?.[0]}
            className="flex flex-row w-full cursor-pointer"
          >
            <input
              name="share-link"
              readOnly
              value={modalShareFile?.linksToShare?.[0]}
              className="w-full h-[52px] px-4 py-1.5 cursor-pointer hover:bg-surface-gray-10 text-secondary rounded-lg border border-surface-strokes !outline-none"
            />
            <OptionButton>
              <GoogleIcon name="link" className="text-[24px] text-primary" />
            </OptionButton>
          </CopyToClipboard>
        </Flex>
        <Text className="text-surface-dark text-body-m">
          Comparte una ficha con tus datos de contacto y los de tu cliente.
        </Text>
        {isNewCustomer && (
          <div className="w-full">
            <Badge type="blue" variant="dark" value="Nuevo cliente" />
          </div>
        )}
        {formIsDisabled && (
          <Text className="text-primary text-body-bold-l py-2">
            Contrata PRIME para poder enviar tu propiedad
          </Text>
        )}
        {isNewCustomer && (
          <Input
            name="name"
            disabled={formIsDisabled}
            value={dataCustomer?.name}
            onChange={handleOnChange}
            className="w-full"
            classNameInput="w-full"
            classNameContainer="w-full"
            classNameLabel="text-secondary"
            labelText={
              isNewCustomer ? 'Nombre del nuevo cliente' : 'Escribe un nombre'
            }
            leftIcon={
              <GoogleIcon name="search" className="text-primary text-[24px]" />
            }
          />
        )}
        {!isNewCustomer && (
          <DropdownContact
            formIsDisabled={formIsDisabled}
            debounceSearchValueCustomer={debounceSearchValueCustomer}
            handleNewCustomer={handleNewCustomer}
            handleResetContact={handleResetContact}
            searchValueCustomer={searchValueCustomer}
            setSearchValueCustomer={setSearchValueCustomer}
            selectedCustomer={selectedCustomer}
            dataCustomer={dataCustomer}
            handleSelectContact={handleSelectContact}
            isLoading={isLoadingSearch}
            isNewCustomer={isNewCustomer}
            resultSearch={resultSearchCustomer}
          />
        )}
        <Input
          value={dataCustomer?.email}
          name="email"
          disabled={formIsDisabled}
          error={
            dataCustomer?.email?.length > 0 && emailIsInvalid
              ? 'Correo inválido'
              : false
          }
          onBlur={() => validateEmail(dataCustomer?.email)}
          className="w-full"
          onChange={handleOnChange}
          labelText="Correo"
          classNameContainer="w-full"
        />
        <Input
          type="phone-number"
          disabled={formIsDisabled}
          name="phone"
          value={dataCustomer?.phone}
          onChange={handleOnChange}
          className="w-full"
          onPhoneCodeChange={(value) => handleOnChangePhoneCode(value)}
          labelText="Whatsapp"
          classNameContainer="w-full"
        />
        <Text className="text-body-m text-surface-dark w-full" align="center">
          Al enviar esta ficha aceptas los{' '}
          <a
            href={`${ROUTES.TERMS_AND_CONDITIONS}`}
            target="_blank"
            rel="noreferrer"
            className="font-bold underline"
          >
            términos y condiciones.
          </a>
        </Text>
      </Modal.Body>
      <Modal.Footer className="w-full py-[9px] px-6" isShowDivider>
        <Button
          variant="secondary"
          isLoading={isLoading}
          isDisabled={isLoading || !allInputsIsFilled || formIsDisabled}
          fullWidth
          onClick={handleOnClick}
        >
          Enviar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
